<script setup lang="ts">
import { inject, computed } from 'vue';
import type { FooterTotalsRowModel, TableModel } from './model';
import ItpDataTableFooterTotalsCell from './ItpDataTableFooterTotalsCell.vue';

const props = defineProps<{ data: any }>();
const row = computed(() => props.data as FooterTotalsRowModel);

const model = inject<TableModel>('model');
if (!model) {
  throw new Error('ItpDataTableFooterTotalsRow missing model injection');
}
</script>

<template>
  <tr class="itp-datatable__footer-totals footer-totals datarow">
    <td
      v-if="model.options.rowSelection"
      class="itp-datatable__table-cell sticky-l bg-light"
      style="left: 0; z-index: 10"
    />

    <td
      v-if="model.options.rowHeader"
      class="itp-datatable__table-cell sticky-l bg-light"
      :style="{ left: model.options.rowSelection ? '20px' : '0' }"
      style="z-index: 10"
    />

    <ItpDataTableFooterTotalsCell
      v-for="col in model.options.columns"
      :key="col.field"
      :row="row"
      :column="col"
    />

    <td
      v-if="model.options.fillEmptyRowSpace !== false"
      class="itp-datatable__table-cell"
      style="width: 100%"
    />

    <td
      v-if="model.options.editable"
      class="itp-datatable__table-cell sticky-r bg-light"
      style="right: 0; z-index: 10"
    />
  </tr>
</template>

<style scoped>
.footer-totals td {
  background-color: #f8f9fa;
  border-top: 2px solid #dee2e6;
}
</style>
